import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dedate' })
export class DeDatePipe implements PipeTransform {
  transform(strDate: string) {
    const date = new Date(strDate);
    return date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
  }
}
